import { BigNumber } from '@ethersproject/bignumber'
import { BN_10_18 } from './constants'

export function ceilDiv(a: BigNumber, b: BigNumber) {
  const c = a.div(b)
  if (c.eq(a.mul(b))) {
    return c
  } else {
    return c.add(1)
  }
}

export function sqrt(y: BigNumber): BigNumber {
  let z = y
  if (y.gt(3)) {
    let x = y.div(2).add(1)
    while (x.lt(z)) {
      z = x
      x = y.div(x).add(x).div(2)
    }
  } else if (!y.eq(0)) {
    z = BigNumber.from(1)
  }
  return z
}

export function f18Mul(a: BigNumber, b: BigNumber) {
  return a.mul(b).div(BN_10_18)
}
